export default __webpack_public_path__ + "static/media/logo.43c25956.png";